import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home'
import Login from '@/page/overview/login'
Vue.use(Router)

import routes from "./routers.js"
import Media from './media.js';
import Data from './data.js';
import Doc from './doc.js';

console.log(routes);

const allRouters = [
  ...routes,
  ...Media,
  ...Data,
  ...Doc
]

let router = new Router({
  mode: 'hash',
  routes: [
  {
    path: '',
    redirect: '/myindex'
  },
  {
    path: '/home',
    component: Home,
    meta: {
      requireAuth: true,
    },
    children: [
      ...allRouters
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: Login,
    meta:{
      title:'用户登录'
    }
  },
  {
    path:'/agreement',
    name:'用户须知',
    component:resolve => require(['@/page/agreement.vue'],resolve),
    meta:{
      title:'用户须知'
    }
  },
  {
    path:'*',
    component:resolve =>require(['@/page/notFound.vue'],resolve)
  }
  ]
})
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js